export const imgsLoaded = function (imgs, progressCb) {
  let loadNums = 0;
  let imgsLength = imgs.length;

  function allResolved(cb) {
    loadNums == imgsLength && cb(imgs);
    progressCb && progressCb(loadNums / imgsLength);
  }

  return new Promise((resolve, reject) => {
    for (let i = 0; i < imgsLength; i++) {
      let img = imgs[i];
      if (img.complete) {
        loadNums++;
        allResolved(resolve);
      } else {
        img.addEventListener('load', () => {
          loadNums++;
          allResolved(resolve);
        });
      }
    }
  });
};

export const imgBitMap = function (imgs) {
  return new Promise((resolve, reject) => {
    // window.createImageBitmap ? Promise.all(imgs.map(v => createImageBitmap(v))).then(res => resolve(res)) : resolve(imgs)
    resolve(imgs)
  });
};

export const setBgImg = function (dom, imgUrl) {
  if (Array.isArray(dom) && Array.isArray(imgUrl)) {
    dom.forEach((v, k) => {
      v.style.backgroundImage = `url(${imgUrl[k]})`;
    })
  } else {
    dom.style.backgroundImage = `url(${imgUrl})`;
  }
}

export const audioPlay = {
  autoplay: false,
  audio: null,
  testAutoPlay() {
    return new Promise(resolve => {
      let audio = document.createElement('audio');
      audio.src = testMp3;
      let autoplay = true;
      let promise = audio.play()
      if (!!promise) {
        promise.then(() => {
          autoplay = true;
          resolve(autoplay);
        }).catch(err => {
          autoplay = false;
          resolve(autoplay);
        })
      } else {
        resolve(autoplay)
      }
    });
  },
  // 监听页面的点击事件，一旦点过了就能autoplay了
  setAutoPlayWhenClick(setAutoPlay) {
    document.addEventListener('click', setAutoPlay);
    document.addEventListener('touchend', setAutoPlay);
  },
  init(audio) {
    // 检测是否能自动播放
    this.audio = audio;
    new Promise((resolve, reject) => {
      audio.play().then(() => {
        resolve(true);
      }).catch(() => {
        resolve(false);
      })
    }).then(res => {
      this.autoplay = res;
      if (!res) {
        console.log('尝试播放失败,添加微信自动播放以及点击自动播放');
        let that = this;
        let setAutoPlay = () => {
          // 设置自动播放为true
          if (this.audio.played.length >= 1) {
            return;
          }
          this.audio.load();
          this.audio.play();
          document.removeEventListener('click', setAutoPlay);
          document.removeEventListener('touchend', setAutoPlay);
          this.autoplay = true;
        }
        this.setAutoPlayWhenClick(setAutoPlay);
        document.addEventListener('WeixinJSBridgeReady', () => {
          audio.play().then(() => {
            console.log('微信自动播放,移除点击播放事件');
            this.removeAutoPlayClickListener(this.setAutoPlay)
          })
        }, false);
      }
    })
  }
};

export const request = (url, header) => {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('GET', url);
    for (let i of Object.keys(header)) {
      xhr.setRequestHeader(i, header[i])
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}

export const addClass = (dom, c) => {
  if (Array.isArray(dom)) {
    for (let i = 0, length = dom.length; i < length; i++) {
      let d = dom[i];
      d.classList.add((Array.isArray(c) && c[i]) || c);
    }
  } else {
    dom.classList.add(c);
  }
}

export const removeClass = (dom, c) => {
  if (Array.isArray(dom)) {
    for (let i = 0, length = dom.length; i < length; i++) {
      let d = dom[i];
      d.classList.remove((Array.isArray(c) && c[i]) || c);
    }
  } else {
    dom.classList.remove(c);
  }
}

export const getStrLen = (str) => {
  let len = 0;
  if (str == "" || str == undefined || str == null)
    return len;
  for (var i = 0; i < str.length; i++) {
    var a = str.charAt(i);
    if (a.match(/[^\x00-\xff]/ig) != null) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
}

export const subStr = (str, max) => {
  let len = 0;
  for (var i = 0; i < str.length; i++) {
    var a = str.charAt(i);
    if (a.match(/[^\x00-\xff]/ig) != null) {
      len += 2;
    } else {
      len += 1;
    }
    if (len > max) {
      console.log(len, max, i)
      break;
    }
  }
  return str.substr(0, i);;
}

export const randomNum = (minNum, maxNum) => {
  return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
}


export const Schedule = (scheduleList = [], start = false) => {
  let n = 0;
  let active = false;

  function next(nextAction) {
    if (!nextAction) {
      return
    } else {
      const [fn, time, cb] = nextAction;
      fn && fn();
      active = true;
      if (time > 0) {
        setTimeout(() => {
          active = false;
          cb && cb();
        }, time)
      } else {
        active = false;
        cb && cb();
      }
    }
  }
  start && next(scheduleList[n])
  return {
    next: function () {
      scheduleList[n + 1] && !active && next(scheduleList[++n])
      this.step = n;
    },
    step: n
  }
}

export const getPolygonsPosition = function (xCenter, yCenter, radius, sides, n) {
  var radAngle = Math.PI * 2 / sides;
  var radAlpha = -Math.PI / 2;
  var rad = radAngle * n + radAlpha;
  var xPos = xCenter + Math.cos(rad) * radius;
  var yPos = yCenter + Math.sin(rad) * radius;
  return {
    x: xPos,
    y: yPos
  }
}

/** 
 * @param {CanvasRenderingContext2D} ctx 
 * @param {Number} xCenter 中心坐标X点 
 * @param {Number} yCenter 中心坐标Y点
 * @param {Number} radius 外圆半径
 * @param {Number} sides 多边形边数
 * @param {Number} alpha 角度 默认270度
 */
function drawPolygons(ctx, xCenter, yCenter, radius, sides, alpha) {
  var radAngle = Math.PI * 2 / sides;
  var radAlpha = (alpha != 'undefined') ? alpha * Math.PI / 180 : -Math.PI / 2;
  ctx.save();
  ctx.beginPath();
  var xPos = xCenter + Math.cos(radAlpha) * radius;
  var yPos = yCenter + Math.sin(radAlpha) * radius;
  ctx.moveTo(xPos, yPos);
  for (var i = 1; i <= sides; i++) {
    var rad = radAngle * i + radAlpha;
    var xPos = xCenter + Math.cos(rad) * radius;
    var yPos = yCenter + Math.sin(rad) * radius;
    ctx.lineTo(xPos, yPos);
  }
  ctx.closePath();
}

/**
 * @param {CanvasRenderingContext2D} ctx 
 * @param {Number} xCenter  
 * @param {Number} yCenter 中心点Y坐标点
 * @param {Number} radius 外圆半径
 * @param {Number} sides 多边形边数
 * @param {Number} alpha 角度 默认270度 
 * @param {Boolean} arc 是否显示外圆
 */
function drawStrokePolygon(ctx, xCenter, yCenter, radius, sides, alpha) {
  drawPolygons(ctx, xCenter, yCenter, radius, sides, alpha);
}

export const getTargetData = function (e) {
  const target = (e.target || e.srcElement) || {};
  return target.dataset;
}